import { EUserRole } from '../enum/user.role.enum';

type TRoutePermissionsMap = {
    iam: {
        access: EUserRole[];
    };
    benefits: {
        access: EUserRole[];
    };
    customer: {
        access: EUserRole[];
    };
    subsidy: {
        access: EUserRole[];
    };
    employees: {
        access: EUserRole[];
    };
    reports: {
        access: EUserRole[];
    };
    uiDemo: {
        access: EUserRole[];
    };
};

const RoutePermissions: TRoutePermissionsMap = {
    iam: {
        access: [EUserRole.SuperAdminCustomer, EUserRole.AdminCustomer]
    },
    benefits: {
        access: [EUserRole.SuperAdminCustomer, EUserRole.AdminCustomer, EUserRole.Approver, EUserRole.PayrollManager]
    },
    customer: {
        access: [EUserRole.SuperAdminCustomer, EUserRole.AdminCustomer]
    },
    employees: {
        access: [EUserRole.SuperAdminCustomer, EUserRole.AdminCustomer, EUserRole.Approver, EUserRole.PayrollManager]
    },
    subsidy: {
        access: [EUserRole.SuperAdminCustomer, EUserRole.AdminCustomer, EUserRole.Approver, EUserRole.PayrollManager]
    },
    reports: {
        access: [EUserRole.SuperAdminCustomer, EUserRole.AdminCustomer, EUserRole.Approver, EUserRole.PayrollManager]
    },
    uiDemo: {
        access: [EUserRole.SuperAdminCustomer, EUserRole.AdminCustomer]
    }
};

export { RoutePermissions, TRoutePermissionsMap };
